<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row align-items-center">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/atencion">Atenciones</router-link>
            &rsaquo;
            <router-link
              :to="{
                name: 'AtencionForm',
                state: { idAtencion: p_idAtencion }
              }"
            >
              Atención {{ p_numero }}
            </router-link>
            &rsaquo; Interconsultas
          </div>
        </div>
        <div class="col-1 text-end">
          <button class="btn-help" type="button" title="Abrir ayuda"
            @click="showModalHelp = true"
            aria-label="Abrir ayuda de interconsultas">
            <span class="material-symbols-outlined">help</span>
          </button>
        </div>
      </div>
    </div>

    <hr />

    <Modal v-model:modelValue="showModalHelp" title="Ayuda — Interconsultas de la Atención">
      <AyudaAtencionInterconsulta />
    </Modal>

    <!-- Bloque: Datos de la Atención -->
    <div class="d-flex justify-content-between align-items-center mb-2">
      <b>Datos de la Atención</b>
      <button class="btn btn-link p-0 text-decoration-none"
        @click.prevent="mostrarBloque = !mostrarBloque">
        <span class="material-symbols-outlined align-middle">
          {{ mostrarBloque ? 'expand_less' : 'expand_more' }}
        </span>
        {{ mostrarBloque ? 'Mostrar menos' : 'Mostrar más información' }}
      </button>
    </div>

    <div class="form-card mb-3">
      <div class="mb-3">
        <div class="row align-items-center">
          <div class="col-1"><label class="col-form-label">Paciente</label></div>
          <div class="col-5">
            <input type="text" class="form-control" v-model="datoAtencion.nombrePaciente" disabled />
          </div>
          <div class="col-1"><label class="col-form-label">Cédula</label></div>
          <div class="col-2">
            <input type="text" class="form-control" v-model="datoAtencion.documentoPaciente" disabled />
          </div>
          <div class="col-1"><label class="col-form-label">Tipo</label></div>
          <div class="col-2">
            <select class="form-select" v-model="datoAtencion.tipo" disabled>
              <option value="I">Inicial</option>
              <option value="S">Subsecuente</option>
            </select>
          </div>
        </div>
      </div>
      <div class="mb-3">
        <div class="row align-items-center">
          <div class="col-1"><label class="col-form-label">Médico</label></div>
          <div class="col-5">
            <input type="text" class="form-control" v-model="datoAtencion.nombreMedico" disabled />
          </div>
          <div class="col-1"><label class="col-form-label">Especial.</label></div>
          <div class="col-5">
            <input type="text" class="form-control" v-model="datoAtencion.nombreEspecialidad" disabled />
          </div>
        </div>
      </div>
      <div class="mb-3">
        <div class="row">
          <div class="col-1"><label class="col-form-label">Motivo</label></div>
          <div class="col-5">
            <textarea class="form-control" v-model="datoAtencion.motivo"
              style="text-transform:uppercase" disabled></textarea>
          </div>
          <div class="col-1"><label class="col-form-label">Obs.</label></div>
          <div class="col-5">
            <textarea class="form-control" v-model="datoAtencion.observacion"
              style="text-transform:uppercase" disabled></textarea>
          </div>
        </div>
      </div>

      <!-- Sección colapsable -->
      <div v-if="mostrarBloque">
        <hr class="my-2" />
        <div class="row">
          <div class="col-2">
            <label class="form-label">Id. Atención</label>
            <input type="text" class="form-control" :value="datoAtencion.idAtencion" disabled />
          </div>
          <div class="col-5">
            <label class="form-label">Fecha Registro</label>
            <input type="text" class="form-control" :value="getFormattedDate(datoAtencion.fechaReg)" disabled />
          </div>
          <div class="col-5">
            <label class="form-label">Fecha Actualización</label>
            <input type="text" class="form-control" :value="getFormattedDate(datoAtencion.fechaAct)" disabled />
          </div>
        </div>
      </div>
    </div>

    <!-- DataTable interconsultas -->
    <DataTable
      :data="interconsultas"
      :columns="columnas"
      idField="idInterconsulta"
      :acciones="true"
      :mostrarBotonTodos="false"
      :mostrarBotonNuevo="estadoPermitido"
      :mostrarBotonExcel="false"
      :mostrarInfo="false"
      :mostrarEditar="false"
      :mostrarVer="false"
      :mostrarEliminar="false"
      mensajeVacio="No hay interconsultas registradas."
      @refresh="cargarInterconsultas"
      @create="abrirModalCrear"
      accionesWidth="120px"
    >
      <template #acciones-fila="{ row }">
        <div class="d-flex gap-1 flex-wrap">
          <button v-if="estadoPermitido"
            class="btn btn-sm btn-outline-warning"
            @click="abrirModalEditar(row.idInterconsulta)"
            title="Editar">
            <span class="material-symbols-outlined" style="font-size:14px">edit</span>
          </button>
          <button class="btn btn-sm btn-outline-primary"
            @click="abrirEditarDet(row.idInterconsulta)"
            title="Detalles">
            <span class="material-symbols-outlined" style="font-size:14px">open_in_new</span>
          </button>
          <button class="btn btn-sm btn-outline-secondary"
            @click="formulario007solicitudPDF(row.idInterconsulta)"
            title="Formulario 007 - Solicitud">
            <span class="material-symbols-outlined" style="font-size:14px;color:red">picture_as_pdf</span>
          </button>
          <button class="btn btn-sm btn-outline-secondary"
            @click="formulario007informePDF(row.idInterconsulta)"
            title="Formulario 007 - Informe">
            <span class="material-symbols-outlined" style="font-size:14px;color:darkred">description</span>
          </button>
          <button v-if="estadoPermitido"
            class="btn btn-sm btn-outline-danger"
            @click="deleteInterconsulta(row.idInterconsulta)"
            title="Borrar">
            <span class="material-symbols-outlined" style="font-size:14px">delete</span>
          </button>
        </div>
      </template>
    </DataTable>

    <!-- Modal crear / editar interconsulta -->
    <Teleport to="body">
      <div class="modal fade" id="ventanaModal" tabindex="-1"
        aria-labelledby="modalInterconsultaLabel" aria-hidden="true" ref="modalRef">
        <div class="modal-dialog modal-xl">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title" id="modalInterconsultaLabel">
                <span class="material-symbols-outlined align-middle me-2" style="font-size:20px">
                  {{ btnCrear_det ? 'add_circle' : 'edit' }}
                </span>
                {{ titulo }}
              </h5>
              <button type="button" class="btn-close btn-close-white"
                @click="cerrarModal" aria-label="Cerrar"></button>
            </div>

            <div class="modal-body">
              <!-- Especialidad y Médico -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-6">
                    <label class="form-label">Especialidad</label>
                    <select class="form-select" v-model="datoInterconsulta.idEspecialidad"
                      @change="fetchMedicos">
                      <option v-for="esp in especialidads"
                        :value="esp.idEspecialidad" :key="esp.idEspecialidad">
                        {{ esp.especialidadNombre }}
                      </option>
                    </select>
                  </div>
                  <div class="col-6">
                    <label class="form-label">Médico</label>
                    <select class="form-select" v-model="datoInterconsulta.idMedico">
                      <option v-for="med in medicos"
                        :value="med.idMedico" :key="med.idMedico">
                        {{ med.nombreCompleto }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Motivo con micrófono -->
              <div class="mb-3">
                <label class="form-label">Motivo</label>
                <div class="textarea-container-mic d-flex align-items-stretch">
                  <textarea class="form-control" rows="4"
                    v-model="datoInterconsulta.motivo"
                    style="text-transform:uppercase" maxlength="250"></textarea>
                  <div class="buttons-container-mic d-flex flex-column ms-2">
                    <button v-if="!isDictatingMotivo" type="button"
                      class="btn btn-light" title="Iniciar Dictado"
                      @click="startDictationMotivo">
                      <span class="material-symbols-outlined"
                        style="font-size:40px;color:orangered;cursor:pointer">mic_off</span>
                    </button>
                    <button v-else type="button"
                      class="btn btn-light" title="Finalizar Dictado"
                      @click="stopDictationMotivo">
                      <span class="material-symbols-outlined"
                        style="font-size:40px;color:green;cursor:pointer">mic</span>
                    </button>
                    <div class="flex-grow-1"></div>
                    <small class="text-muted mt-auto text-end">
                      {{ (datoInterconsulta.motivo || '').length }} / 250
                    </small>
                  </div>
                </div>
              </div>

              <!-- Cuadro con micrófono -->
              <div class="mb-3">
                <label class="form-label">Cuadro</label>
                <div class="textarea-container-mic d-flex align-items-stretch">
                  <textarea class="form-control" rows="4"
                    v-model="datoInterconsulta.cuadro"
                    style="text-transform:uppercase" maxlength="250"></textarea>
                  <div class="buttons-container-mic d-flex flex-column ms-2">
                    <button v-if="!isDictatingCuadro" type="button"
                      class="btn btn-light" title="Iniciar Dictado"
                      @click="startDictationCuadro">
                      <span class="material-symbols-outlined"
                        style="font-size:40px;color:orangered;cursor:pointer">mic_off</span>
                    </button>
                    <button v-else type="button"
                      class="btn btn-light" title="Finalizar Dictado"
                      @click="stopDictationCuadro">
                      <span class="material-symbols-outlined"
                        style="font-size:40px;color:green;cursor:pointer">mic</span>
                    </button>
                    <div class="flex-grow-1"></div>
                    <small class="text-muted mt-auto text-end">
                      {{ (datoInterconsulta.cuadro || '').length }} / 250
                    </small>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button class="btn btn-secondary btn-sm" @click="cerrarModal">
                <span class="material-symbols-outlined align-middle" style="font-size:18px">close</span>
                Cancelar
              </button>
              <button v-if="btnCrear_det" type="button"
                class="btn btn-success btn-sm d-flex align-items-center gap-1"
                @click.prevent="guardarInterconsulta">
                <span class="material-symbols-outlined" style="font-size:18px">save</span>
                Guardar
              </button>
              <button v-if="btnEditar_det" type="button"
                class="btn btn-primary btn-sm d-flex align-items-center gap-1"
                @click.prevent="guardarEditInterconsulta">
                <span class="material-symbols-outlined" style="font-size:18px">update</span>
                Actualizar
              </button>
            </div>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- Formulario 007 - Solicitud -->
    <Modal v-model:modelValue="showModalSolicitud" title="Formulario 007 - Solicitud">
      <DocVerFirmarGuardar :idReporte="3" :idDocumento="idInterconsultaDocumento" />
    </Modal>

    <!-- Formulario 007 - Informe -->
    <Modal v-model:modelValue="showModalInforme" title="Formulario 007 - Informe">
      <DocVerFirmarGuardar :idReporte="4" :idDocumento="idInterconsultaDocumento" />
    </Modal>

    <Footer />
  </div>
</template>

<script>
import Layout                    from '@/components/Layout.vue'
import Footer                    from '@/components/Footer.vue'
import DataTable                 from '@/components/DataTable.vue'
import DocVerFirmarGuardar       from '../utils/DocVerFirmarGuardar.vue'
import SpeechDictation           from '@/modules/microfono.js'
import dateFormat                from '@/modules/dateFormat.js'
import { validarForm }           from '@/modules/validacionesForms.js'
import api                       from '@/services/api'
import { Modal }                 from 'bootstrap'
import Swal                      from 'sweetalert2'
import AyudaAtencionInterconsulta from '@/views/ayuda/AyudaAtencionInterconsulta.vue'

export default {
  name: 'AtencionInterconsulta',
  components: { Layout, Footer, DataTable, AyudaAtencionInterconsulta, DocVerFirmarGuardar },

  props: {
    p_idAtencion:     { type: Number, required: true },
    p_estadoAtencion: { type: String, required: true },
    p_numero:         { type: String, required: true },
  },

  data() {
    return {
      datoAtencion:             {},
      mostrarBloque:            false,
      interconsultas:           [],
      datoInterconsulta:        {},
      titulo:                   '',
      btnCrear_det:             false,
      btnEditar_det:            false,
      modalInstance:            null,
      especialidads:            [],
      medicos:                  [],
      dictation:                new SpeechDictation(),
      isDictatingMotivo:        false,
      isDictatingCuadro:        false,
      showModalHelp:            false,
      showModalSolicitud:       false,
      showModalInforme:         false,
      idInterconsultaDocumento: null,
      columnas: [
        { field: 'especialidad', label: 'Especialidad' },
        { field: 'medicoInter',  label: 'Médico' },
        { field: 'cuadro',       label: 'Cuadro' },
      ],
    }
  },

  computed: {
    estadoPermitido() {
      return ['PENDIENTE', 'PROCESO'].includes(this.p_estadoAtencion)
    },
  },

  mounted() {
    this.cargarAtencion()
    this.cargarInterconsultas()
    this.fetchEspecialidads()
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.$nextTick(() => {
      if (this.$refs.modalRef) {
        this.modalInstance = new Modal(this.$refs.modalRef)
      }
    })
  },

  beforeUnmount() {
    if (this.isDictatingMotivo) this.stopDictationMotivo()
    if (this.isDictatingCuadro) this.stopDictationCuadro()
    if (this.modalInstance) this.modalInstance.dispose()
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },

    // ── Atención ──────────────────────────────────────────────────────────
    async cargarAtencion() {
      try {
        const resp = await api.get(`/vwatencions/${this.p_idAtencion}`)
        this.datoAtencion = resp.data
      } catch (err) {
        console.error('Error cargando atención:', err)
      }
    },

    // ── Interconsultas ────────────────────────────────────────────────────
    async cargarInterconsultas() {
      try {
        const resp = await api.get(`/vwinterconsultas/idatencion/${this.p_idAtencion}`)
        this.interconsultas = resp.data.reverse()
      } catch (err) {
        console.error('Error cargando interconsultas:', err)
      }
    },

    validarInterconsulta() {
      return validarForm(
        this.datoInterconsulta,
        ['idEspecialidad', 'idMedico', 'motivo', 'cuadro'],
        ['idEspecialidad', 'idMedico', 'motivo', 'cuadro']
      )
    },

    abrirModalCrear() {
      this.datoInterconsulta = {}
      this.titulo            = 'Registrar Interconsulta'
      this.btnCrear_det      = true
      this.btnEditar_det     = false
      this.modalInstance?.show()
    },

    async abrirModalEditar(idInterconsulta) {
      this.titulo        = 'Editar Interconsulta'
      this.btnCrear_det  = false
      this.btnEditar_det = true
      try {
        const resp = await api.get(`/vwinterconsultas/${idInterconsulta}`)
        this.datoInterconsulta = resp.data
      } catch (err) {
        console.error('Error cargando interconsulta:', err)
      }
      this.modalInstance?.show()
    },

    cerrarModal() {
      this.modalInstance?.hide()
    },

abrirEditarDet(idInterconsulta) {
  if (idInterconsulta) {
    this.$router.push({
      name: 'InterconsultaOrigenForm',
      state: {
        numeroAtencion:  this.p_numero,
        estadoAtencion:  this.p_estadoAtencion,
        idInterconsulta: idInterconsulta,
      }
    });
  }
},

    async guardarInterconsulta() {
      if (this.validarInterconsulta() !== 1) return
      try {
        this.datoInterconsulta.idEmpresa  = window.sessionStorage.getItem('idEmpresa')
        this.datoInterconsulta.idAtencion = this.datoAtencion.idAtencion
        await api.post('/interconsultas', this.datoInterconsulta)
        this.cerrarModal()
        await Swal.fire({ icon: 'success', title: 'Guardado', text: 'Interconsulta creada exitosamente.', timer: 2000, showConfirmButton: false })
        this.cargarInterconsultas()
      } catch {
        Swal.fire({ icon: 'error', title: 'Error', text: 'Inténtelo de nuevo.' })
      }
    },

    async guardarEditInterconsulta() {
      if (this.validarInterconsulta() !== 1) return
      try {
        await api.post('/interconsultas', this.datoInterconsulta)
        this.cerrarModal()
        await Swal.fire({ icon: 'success', title: 'Actualizado', text: 'Interconsulta actualizada exitosamente.', timer: 2000, showConfirmButton: false })
        this.cargarInterconsultas()
      } catch {
        Swal.fire({ icon: 'error', title: 'Error', text: 'Inténtelo de nuevo.' })
      }
    },

    async deleteInterconsulta(idInterconsulta) {
      const { isConfirmed } = await Swal.fire({
        title: '¿Eliminar interconsulta?',
        text: 'Esta acción no se puede deshacer.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dc3545',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      })
      if (!isConfirmed) return
      try {
        await api.delete(`/interconsultas/${idInterconsulta}`)
        this.cargarInterconsultas()
      } catch {
        Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo eliminar.' })
      }
    },

    // ── Catálogos ──────────────────────────────────────────────────────────
    fetchEspecialidads() {
      api.get(`/vwespeemprs/idempresa/${window.sessionStorage.getItem('idEmpresa')}`)
        .then(r => { this.especialidads = r.data })
        .catch(err => console.error('Error cargando especialidades:', err))
    },

    fetchMedicos() {
      const idEmpresa      = window.sessionStorage.getItem('idEmpresa')
      const idEspecialidad = this.datoInterconsulta.idEspecialidad
      if (!idEspecialidad) return
      api.get(`/vwmedicos/idempresa-idespecialidad?idempresa=${idEmpresa}&idespecialidad=${idEspecialidad}`)
        .then(r => { this.medicos = r.data })
        .catch(err => console.error('Error cargando médicos:', err))
    },

    // ── Formularios PDF ────────────────────────────────────────────────────
    formulario007solicitudPDF(idInterconsulta) {
      this.idInterconsultaDocumento = idInterconsulta
      this.showModalSolicitud       = true
    },

    formulario007informePDF(idInterconsulta) {
      this.idInterconsultaDocumento = idInterconsulta
      this.showModalInforme         = true
    },

    // ── Dictado ────────────────────────────────────────────────────────────
    startDictationMotivo() {
      this.isDictatingMotivo = true
      this.dictation.startDictation(
        t => { this.datoInterconsulta.motivo = t },
        this.datoInterconsulta.motivo
      )
    },
    stopDictationMotivo() {
      this.isDictatingMotivo = false
      this.dictation.stopDictation()
    },
    startDictationCuadro() {
      this.isDictatingCuadro = true
      this.dictation.startDictation(
        t => { this.datoInterconsulta.cuadro = t },
        this.datoInterconsulta.cuadro
      )
    },
    stopDictationCuadro() {
      this.isDictatingCuadro = false
      this.dictation.stopDictation()
    },
  },
}
</script>

<style scoped>
.btn-help {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: #0d6efd;
}
.btn-help .material-symbols-outlined {
  font-size: 32px;
  transition: color 0.2s;
}
.btn-help:hover .material-symbols-outlined {
  color: #0a58ca;
}
</style>
<style src="@/assets/css/microfono.css" scoped></style>
<style src="@/assets/css/listaRegistros.css" scoped></style>